import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Benefits.css";

class Benefits extends Component {
  static propTypes = {
    title: PropTypes.string,
    advantages: PropTypes.arrayOf(
      PropTypes.shape({
        order: PropTypes.number,
        name: PropTypes.string,
        text: PropTypes.string,
        image: PropTypes.string,
      })
    ),
  };

  render() {
    const { title, advantages } = this.props;

    return (
      <div className="benefits">
        <h3 className="text text--h3 benefits__title">{title}</h3>
        <div className="row">
          {advantages.map((item, index) => (
            <div
              className="col col--6 colVertTablet--12 benefits__item"
              key={`benefits__item-${index}`}
            >
              <img
                className="benefits__logo"
                src={item.image}
                alt={item.title}
              />
              <div className="benefits__name">{item.name}</div>
              <div
                className="benefits__text"
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Benefits;



// WEBPACK FOOTER //
// ./src/components/Benefits/index.js